<div class=" mx-auto mt-8 p-4  lg:mt-14 lg:p-6 bg-gray-100 dark:bg-[#1B3C53] rounded-xl ">
  <h2 class="text-xl font-semibold mb-6 lg:text-xl">Uploaded Reports</h2>

  <div>
    <div
      class="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-white  rounded-xl p-4 sm:p-5 mb-4 transition-shadow hover:shadow-lg dark:bg-gray-800 dark:text-white"
      *ngFor="let report of reports"
    >
      <div class="flex items-start sm:items-center gap-4">
        <i class="pi pi-file-pdf text-[24px] text-red-600 lg:text-[28px]"></i>

        <div class="flex flex-col ">
          <div class="text-[16px] lg:text-[15px] font-medium">{{ report.name }}</div>  

          <div class="text-[13px] text-gray-600  dark:text-white flex items-center gap-2">
            <span>{{ report.uploadedDate }}</span>
            <span class="w-1.5 h-1.5 bg-gray-400 rounded-full"></span>
            <span>{{ report.size }}</span>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-4 mt-3 sm:mt-0">
        <i
          class="pi pi-eye text-[20px] lg:text-[20px] cursor-pointer hover:opacity-75 transition"
        ></i>

        <i
          class="pi pi-trash text-[20px] lg:text-[20px] text-red-600 cursor-pointer hover:opacity-75 transition"
        ></i>
      </div>
    </div>
  </div>

  <button
    class="mt-2 bg-blue-500 text-white font-medium text-[13px] lg:text-[15px] py-2 px-3 rounded-lg shadow hover:bg-blue-400 transition cursor-pointer"
     (click)="fileInput.click()">
     <i class="pi pi-upload mr-1 "></i> Upload Report
  </button>
  <input type="file" #fileInput style="display: none;" />
</div>
